// extracted by mini-css-extract-plugin
module.exports = {"bottom":"PageBody_bottom__Fx7ml","headerAndChildren":"PageBody_headerAndChildren__05npJ","top":"PageBody_top__RqKE0"};